import { FC, memo, useState } from 'react'
import { DatePicker } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import spclasses from '../SetCourseClassDirectionModal/purchase.module.css'
import { CheckBoxLabel } from '@UI/CheckBox'
import InfoComp from '@pages/Admin/CRMSettings/components/InfoComp/InfoComp'

export interface EnrollDateCheckboxProps {
  value?: string | null
  onChange?: (value: string | null) => void
}

const EnrollDateCheckbox: FC<EnrollDateCheckboxProps> = memo(
  ({ value, onChange }) => {
    const [isChecked, setIsChecked] = useState(!!value)

    const handleCheckboxChange = (checked: boolean) => {
      setIsChecked(checked)
      if (!checked) {
        onChange?.(null)
      }
    }

    const handleDateChange = (date: Dayjs | null) => {
      if (date) {
        onChange?.(date.format('YYYY-MM-DD'))
      } else {
        onChange?.(null)
      }
    }

    return (
      <div className={spclasses.inputWithLabel}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CheckBoxLabel
            type="button"
            value={isChecked}
            onClick={() => handleCheckboxChange(!isChecked)}
            label="Оплата не с сегодня"
            className={spclasses.checkboxWithLabel}
            style={{
              justifyContent: 'flex-start',
              paddingTop: '4px',
              paddingBottom: '4px',
              height: 'auto',
            }}
          />
          <InfoComp text="Вы можете продать обр. Программу таким образом, что учащийся купит её сегодня на Н месяцев, но оплата засчитается с данного числа и на выбранный пользователем период. (Доступ к курсу всё равно откроется сразу же). Удобная функция для запусков потоков в определенный день" />
        </div>
        {isChecked && (
          <DatePicker
            className={spclasses.datePicker}
            placeholder="Выберите дату с какой начнётся оплата"
            value={value ? dayjs(value) : null}
            onChange={handleDateChange}
            format="DD.MM.YYYY"
          />
        )}
      </div>
    )
  },
)

export default EnrollDateCheckbox
